import { CartDrawer as RecoveredCartDrawer } from 'vl-recovered/cart-drawer'

export class CartDrawer extends RecoveredCartDrawer {
  // aside 状态由真实推荐商品响应决定，不能按购物车数量推断。
  updateAsideProductsByParsedState(_parsedState): void {}
}
